import React, {useState, useEffect} from 'react';
import { Helmet } from 'react-helmet';
import brand from 'dan-api/dummy/brand';
import PapperBlock from 'dan-components/PapperBlock/PapperBlock';
import SearchForm from '../../../components/Forms/SearchForm';
import List from '../../../components/Lists/List';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import MySnackbar from '../../../components/Notification/StyledNotif';
import { connect } from 'react-redux';
import { onFetchIndexPaymentFormAction, onFetchQrIssuePaymentFormAction } from '../../../redux/actions/paymentForm';
import accessToken from '../../../utils/accessToken';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../../components/Forms/user-jss';
import {enumToJa, sliceText} from '../../../utils/format';
import Loading from '../../../components/Loading/index'
import UrlScriptDialog from '../../../components/Dialog/UrlScriptDialog';
import { reset } from 'redux-form/immutable';

function Index(props) {
  const { classes } = props;
  const location = props.location
  const { companies } = props.internalValues

  const title = brand.name + ' - 決済フォーム一覧';
  const description = brand.desc;
  const url = '/admin/payment_form/'

  // 検索項目
  const [searchItems, setSearchItems] = useState(
    [
      // TODO 通常決済以外の決済種別が利用できるようになり次第コメント解除
      // { label: "決済方法" , name: "type" , value: "" , formType: "select", menuItems: [{key: '通常決済' , value: 'normal_payment'} , {key: '継続課金決済' , value: 'subscription_payment'}　, {key: '顔認証決済' , value: 'face_auth_payment'}]},
      { label: "公開開始日〜", name: "public_from", value: null, formType: "datetime" },
      { label: "〜公開終了日", name: "public_to", value: null, formType: "datetime" },
      { label: "フォーム名" , name: "name" , value: "" , formType: "text"},
      { label: "ステータス" , name: "status" , value: "" , formType: "select" , menuItems: [{key: '有効' , value: '1'} , {key: '無効' , value: '0'}]},
      { label: "加盟店名", name: "company_id", value: "", formType: "select", super: true,
        menuItems: companies ? companies.map( (company) => ({key: company.name, value: company.id} )) : null
      }
    ]
  )

  const [listItems, setlistItems] = useState(
    [
      { label: "加盟店名", name: "company", super: true},
      { label: "最終更新日", name: "updated-at-date"},
      { label: "フォーム名", name: "name", format: (value)=>{return sliceText(value['name'])}},
      { label: "決済方法", name: "type", format: (value)=>{return enumToJa(value['payment-form-type'])}},
      { label: "ステータス", name: "status", format: (value)=>{return enumToJa(value['status'])}}
    ]
  )

  const [urlScriptData, setUrlScriptData] = useState(
    { 
      url: "",
      open: false
    }
  );

  useEffect(() => {
    submitForm();
    if (location.createdFormUrl){
      setUrlScriptData(
        {
          url: location.createdFormUrl,
          open: true
        }
      )
    }
  }, []);

  const urlScriptOpen = (form) => {
    props.onFetchQrIssuePaymentForm({
      accessToken: accessToken(props),
      data: {id: form.id},
      onSuccess: data => {
        setUrlScriptData(
          {
            url: data.url,
            open: true
          }
        )
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  const [actions, setActions] = useState(
    [
      { label: "埋め込みコード", function: urlScriptOpen}
    ]
  )

  // 一覧
  const [loading, setLoading] = useState(true);
  const [paymentFormData, setPaymentFormData] = useState("")
  
  const submitForm = (values, page = 1) => {
    let data = {}
    searchItems.forEach(item => { data[item.name] = item.value})
    data.page = page
    props.onFetchIndexPaymentForm({
      accessToken: accessToken(props),
      data: data,
      onSuccess: data => {
        const item = data
        setPaymentFormData(item)
        item.data.length == 0 ? displayNotification("検索結果がありませんでした", 'warning') : setLoading(false)
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  // メッセージ関連
  const [notification, setNotification] = useState({
    openStyle: location.message ? true : false,
    message: location.message ? location.message : '',
    variant: location.message ? location.variant : 'info'
  });
  const displayNotification = (message , valiant ='error') => {
    setNotification({
      openStyle: true,
      message: message,
      variant: valiant
    });
  }

  const changeValue = (index, value) => {
    searchItems[index].value = value
    setSearchItems(searchItems.slice())
  }

  const clearHandler = () => {
    props.resetForm();
    searchItems.forEach(item => {
      switch (item.formType) {
        case "select":
        case "text":
          item.value = "";
          return;
        case "datetime":
          item.value = null;
          return;
        default:
          item.value = "";
          return;
      }
    });
    submitForm();
  }

  return (
    <div>
      <Helmet>
      <title>{title}</title>
      </Helmet>
      <PapperBlock title="決済フォーム検索" whiteBg icon="ios-search-outline" desc="">
        <section className={classes.formWrap}>
          <Grid container spacing={3}>
            { searchItems.map( (item, index) => {
                return(
                  <Grid key={index} item xs={12} sm={6}>
                    <SearchForm
                      searchItem={item}
                      key={index}
                      id={index}
                      changeValue={changeValue}
                      role={props.internalValues.role}
                      initialValues={{public_from: null, public_to: null, name: '', status: '', company_id: ''}}
                    />
                  </Grid>
                )}
              )
            }
          </Grid>
        </section>
        <div className={classes.btnArea}>
          <Grid container justifyContent="center">
            <Button variant="contained" color="primary" size="large" onClick={submitForm}>
              検索
            </Button>
            <Button variant="contained" color="primary" size="large" onClick={clearHandler}>
              検索条件クリア
            </Button>
          </Grid>
        </div>
      </PapperBlock>
      {/*検索を開始するまでは一覧は表示しない
         検索を開始し、管理者一覧APIが終了するまではローディング画面
         管理者一覧APIが終了し、データが格納されていない場合は一覧は表示しない
         管理者一覧APIが終了し、データが格納されている場合は一覧を表示*/}
      {loading || paymentFormData.data.length === 0 ?  "" :
          <PapperBlock title="決済フォーム一覧" whiteBg icon="ios-list"desc="">
            { props.loadingPaymentFormIndex ? 
              <div><List listItems={listItems} searchResult={paymentFormData} url={url} submitForm={submitForm} role={props.internalValues.role} actions={actions}/><Loading /></div> :
              <List listItems={listItems} searchResult={paymentFormData} url={url} submitForm={submitForm} role={props.internalValues.role} actions={actions}/>
            }
          </PapperBlock>
      }
      <UrlScriptDialog urlScriptData={urlScriptData} />
      <MySnackbar onClose={() => setNotification({...notification, openStyle:false})} notification={notification} />
    </div>
  );
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    internalValues: state.getIn(['internalReducers', 'internalValues']),
    loadingPaymentFormIndex: state.getIn(['paymentFormReducers', 'loadingPaymentFormIndex'])
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchIndexPaymentForm: data => {
      dispatch(onFetchIndexPaymentFormAction(data));
    },
    onFetchQrIssuePaymentForm: data => {
      dispatch(onFetchQrIssuePaymentFormAction(data));
    },
    resetForm: () => {
      dispatch(reset('searchForm'));
    },
  };
};

const FormInit = connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);

export default withStyles(styles)(withCookies(withRouter(FormInit)));